import { Grid } from "@mui/material";
import PartnerSliders from "../../PartnerSliders";

function Brand() {
  return (
    <Grid
      container
      sx={{
        position: "relative",
        minHeight: { xs: "30vh", md: "50vh" },
        justifyContent: "space-around",
        flexDirection: "column",
        padding: { xs: "48px 0", md: "60px 0" },
        maxWidth: "1440px",
        margin: "auto",
      }}
    >
      <PartnerSliders
        title="Our Financial Partners"
        titleMargin={"25px auto"}
        width={240}
        numbers={4}
      />
    </Grid>
  );
}

export default Brand;
